import { Checkbox, Form } from "@/components/Form";
import * as z from "zod";
import { Button } from "@/components/Elements";
import {
  useLazyGetAppSettingsQuery,
  useUpdateAppSettingMutation,
} from "../api/setting";
import { AppSettingModel } from "../types";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/store/reducers";

function buildDynamicSchema(settings: AppSettingModel[]) {
  const shape: Record<string, z.ZodTypeAny> = {};

  settings.forEach(({ key }) => {
    shape[key] = z.coerce.string().optional();
  });

  return z.object(shape);
}

export const Settings = () => {
  const [updateAppSetting] = useUpdateAppSettingMutation();
  const [getAppSettings] = useLazyGetAppSettingsQuery();
  const appSettings = useSelector(
    (state: RootState) => state.setting.appSettings
  );
  const [schema, setSchema] = useState<any>(null);

  useEffect(() => {
    getAppSettings();
  }, []);

  useEffect(() => {
    if (appSettings) {
      // Build schema
      const dynamicSchema = buildDynamicSchema(appSettings);
      setSchema(dynamicSchema);
    }
  }, [appSettings]);

  const defaultValues = useMemo(() => {
    if (appSettings) {
      // Build default values
      const defaultValues: Record<string, any> = {};
      appSettings.forEach((setting) => {
        defaultValues[setting.key] = setting.value == "true";
      });

      return defaultValues;
    }

    return {};
  }, [appSettings]);

  const handleUpdate = async (payload: any) => {
    updateAppSetting(
      Object.keys(payload).map((key) => ({
        key,
        value: payload[key],
      }))
    );
  };

  return (
    <Form<z.infer<typeof schema>, typeof schema>
      onSubmit={async (values) => {
        handleUpdate(values);
      }}
      schema={schema}
      options={{ values: defaultValues }}
    >
      {({ register, handleSubmit }) => (
        <div className="p-[10px]">
          {appSettings?.map((item) => (
            <Checkbox
              key={item.key}
              label={item.displayKey}
              className="w-6 h-6"
              registration={{ ...register(item.key) }}
            />
          ))}
          <Button
            onClick={handleSubmit(handleUpdate, (error) => {
              console.log("error", error);
            })}
          >
            Update
          </Button>
        </div>
      )}
    </Form>
  );
};
